import request from '../../utils/request';

export const search = (param) => {
    return request({
        url: '/sourcing/search',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const querySubmitData = (param) => {
    return request({
        url: '/sourcing/querySubmitData',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}
export const sourcingSubmit = (param) => {
    return request({
        url: '/sourcing/submit',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}

export const sendSourcingMail = (param) => {
    return request({
        url: '/sourcing/sendSourcingMail',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: param
    })
}

export default {
    souringToAudit: (sourcingId) => {
        return request({
            url: '/sourcing?uses=audit',
            method: 'get',
            params: {sourcingId:sourcingId}
        })
    },
    auditCommit: (param) => {
        return request({
            url: '/sourcing/commit',
            method: 'post',
            data: param
        })
    },
    startNewTask:(param)=>{
        return request({
            url:`/sourcing/newTask`,
            method: 'put',
            data: param
        })
    },
    onExport:(sourcingId)=> {
      return request({
          url: `sourcing/exportDetail/${sourcingId}`,
          method: 'post',
          responseType: 'blob',
          fullResponse: true
      })
    },
}
